'use client';

import { useState, useEffect } from 'react';
import Image from 'next/image';

const GalleryGrid = ({ sectionTitle = 'Projects', images, sectionId }) => {
  const [selectedImage, setSelectedImage] = useState(null);

  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape') {
        setSelectedImage(null);
      }
    };

    if (selectedImage) {
      document.addEventListener('keydown', handleEscape);
      document.body.style.overflow = 'hidden';
    }

    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = 'unset';
    };
  }, [selectedImage]);

  if (!images?.length) return null;

  return (
    <>
      <div className="flex flex-col gap-8 lg:gap-12" id={sectionId}>
        <h2 className="pb-4 text-center text-2xl font-bold text-brittainRed uppercase sm:text-3xl md:text-4xl lg:text-start lg:text-largeh2">
          {sectionTitle}
        </h2>
        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3">
          {images.map((imageSource) => (
            <div
              key={imageSource}
              className="relative aspect-square cursor-pointer rounded-xl shadow-md shadow-black/70 transition-transform duration-200 hover:scale-105"
              onClick={() => setSelectedImage(imageSource)}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  setSelectedImage(imageSource);
                }
              }}
              aria-label={`View ${imageSource} in full size`}
            >
              <Image
                src={imageSource}
                alt={imageSource}
                fill
                className="rounded-xl object-cover"
                sizes="(max-width: 768px) 100vw, (max-width: 1024px) 50vw, 33vw"
              />
            </div>
          ))}
        </div>
      </div>

      {/* Modal */}
      {selectedImage && (
        <div
          className="fixed inset-0 z-[100] flex items-center justify-center bg-black/90 p-4"
          onClick={() => setSelectedImage(null)}
          role="dialog"
          aria-modal="true"
          aria-label="Image modal"
        >
          <button
            className="absolute top-4 right-4 z-[101] flex size-16 items-center justify-center rounded-full bg-gray-600 text-3xl font-light text-white transition-colors hover:cursor-pointer hover:bg-white/30 focus:ring-2 focus:ring-white focus:outline-none"
            onClick={() => setSelectedImage(null)}
            aria-label="Close modal"
          >
            &times;
          </button>
          <div
            className="relative max-h-[90vh] max-w-[90vw] min-w-[300px]"
            onClick={(e) => e.stopPropagation()}
          >
            <Image
              src={selectedImage}
              alt={selectedImage}
              width={1440}
              height={1080}
              className="max-h-[90vh] w-auto min-w-[300px] rounded-lg object-contain ring-4 ring-white"
              sizes="90vw"
              quality={90}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default GalleryGrid;
